import React, { useEffect, useState } from "react";

const InfoCard = (props) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  const [customerinfo, setCustomerinfo] = useState({});
  useEffect(() => {
    setCustomerinfo({
      name: props?.$store?.user?.customerName,
      mobile: props?.$store?.user?.mobileNumber,
      email: props?.$store?.user?.emailAddress,
    });
  }, []);

  const { data } = props;
  let dob = data?.dob;
  const date_of_birth = new Date(dob).dateToDDMMYYYY(new Date(dob));
  const age = new Date(dob).getAge();
  var address, docproof, docprooflink;
  if (data?.aadharCardInfo) {
    address = data?.aadharCardInfo?.address;
    // (data?.addresses[0]?.address1 !== null
    //   ? data?.addresses[0]?.address1?.toTitleCase()
    //   : "") +
    // (data?.addresses[0]?.address2 !== null
    //   ? `, ${data?.addresses[0]?.address2?.toTitleCase()}`
    //   : "") +
    // (data?.addresses[0]?.address3 !== null
    //   ? `, ${data?.addresses[0]?.address3?.toTitleCase()}.`
    //   : "");

    docproof = `${_enum.DOC_TYPES_MAP[data?.addresses[0]?.docType] || "-"
      }`;
    docprooflink = data?.addresses[0]?.fileId;
  } else {
    address = "";
  }

  var pincode;
  if (data?.aadharCardInfo) {
    pincode = `${data?.aadharCardInfo?.pincode}`;
  } else {
    pincode = "";
  }

  if (props?.data) {
    let name = props?.data?.customerName;
    let firstLetter = name.charAt(0); // Get the first letter of the first word
    let secondLetterIndex = name.indexOf(" ") + 1; // Get the index of the first letter of the word after the space
    let secondLetter = name.charAt(secondLetterIndex); // Get the second letter of the word after the space
    let result = firstLetter + secondLetter; // Concatenate the first and second letters
    var initialValue = result ? result : "";
  }

  console.log({ data });

  return (
    <div className="info_card">
      <div className="content">
        <div className="header_section">
          <div className="name_card">
            <div className="avatar_circle">{initialValue || ""}</div>
            <h2 className="name">{data?.customerName || "-"}</h2>
          </div>
          <div className="user_id_badge">
            User ID: <span>{data?.customerId || "-"}</span>
          </div>
        </div>

        <div className="separator_line"></div>

        <div className="details_grid">
          <div className="detail_item">
            <span className="label">Gender</span>
            <span className="value">{data?.gender?.toTitleCase() || "-"}</span>
          </div>
          <div className="detail_item">
            <span className="label">Date of Birth</span>
            <span className="value">{date_of_birth || "-"}</span>
          </div>
          <div className="detail_item">
            <span className="label">Age</span>
            <span className="value">{age || "-"}</span>
          </div>
          <div className="detail_item">
            <span className="label">Mobile No.</span>
            <span className="value">{data?.mobileNumber || "-"}</span>
          </div>
          <div className="detail_item">
            <span className="label">Email ID</span>
            <span className="value">{data?.emailAddress || "-"}</span>
          </div>
          <div className="detail_item">
            <span className="label">Pin Code</span>
            <span className="value">{pincode || "-"}</span>
          </div>

          <div className="detail_item col_span_2">
            <span className="label">Aadhar Address</span>
            <span className="value whitespace-preline">{address || "-"}</span>
          </div>
          <div className="detail_item col_span_2">
            <span className="label">Document Proof</span>
            <div className="value d-flex flex-wrap">
              <span className="whitespace-preline">{docproof || "-"}</span>
              <span className="ms-2">
                {docprooflink && (
                  <a
                    href={`${BASE_URL}${docprooflink}`}
                    className="download_link white"
                  >
                    Download
                  </a>
                )}
              </span>
            </div>
          </div>
        </div>

        {data?.status !== "COMPLETED" && (
          <button
            className="edit_btn"
            onClick={(...args) => props.onEdit(...args, "profiledetails")}
          >
            <i className="fa fa-pencil"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default constore(InfoCard);
